<script>
export const group = 'Full'
</script>

<script setup>
import Video from '../default/Video.vue'
</script>

<template>
  <Video />
</template>
